import { giphyGreen, giphyRed } from '@giphy/colors'

import { useEffect } from 'react'
import styled, { css } from 'styled-components'
import { EditPanelFieldComponentProps } from '..'

const RADIO_SIZE = 22
const RADIO_COLOR = `rgba(166, 166, 166, .4)`

const RadioButton = styled.div<{ $isChecked: boolean; $isYes?: boolean }>`
    background: transparent;
    border: 2px solid ${RADIO_COLOR};
    border-radius: 50%;
    box-sizing: border-box;
    height: ${RADIO_SIZE}px;
    left: 0;
    position: relative;
    top: 0;
    width: ${RADIO_SIZE}px;
    &:after {
        background: ${RADIO_COLOR};
        border-radius: inherit;
        bottom: 2px;
        content: '';
        left: 2px;
        position: absolute;
        right: 2px;
        top: 2px;
        transition: background-color 0.2s ease-out;
        background-color: transparent;
        ${({ $isChecked, $isYes }) => {
            if ($isYes && $isChecked) {
                return css`
                    background-color: ${giphyGreen};
                `
            }
            if (!$isYes && $isChecked) {
                return css`
                    background-color: ${giphyRed};
                `
            }
            return css`
                background-color: transparent;
            `
        }}
    }
    pointer-events: none;
`

const RadioButtonContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 8px;
    opacity: 0.5;
`

const RadioLabel = styled.label`
    margin-left: 8px;
    font-size: 0.9em;
`

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export default ({ metadata }: EditPanelFieldComponentProps) => {
    const value = metadata.is_searchable

    useEffect(() => {}, [metadata.is_indexed])

    return (
        <Container>
            <RadioButtonContainer>
                <RadioButton $isChecked={value === false} $isYes={false} />
                <RadioLabel>No</RadioLabel>
            </RadioButtonContainer>
            <RadioButtonContainer>
                <RadioButton $isChecked={value === true} $isYes={true} />
                <RadioLabel>Yes</RadioLabel>
            </RadioButtonContainer>
        </Container>
    )
}
